import axios from 'axios';
const httpClient = axios.create({
	baseURL: '/apps3/cheque-order'
});

const init = () => httpClient.get('/health-check');
const getBranches = () => httpClient.get('/init');
const sendForm = (data) => httpClient.post('/validate', data);
const captcha = () => httpClient.get('/captcha');

export const useChequeOrderApi = () => ({
	init,
	getBranches,
	sendForm,
	captcha
});
